/* Real Shopify cart bridge. All totals in the drawer come from Shopify. */
(() => {
  'use strict';
  const route = (path) => ((window.Shopify && Shopify.routes.root) || '/') + path;
  let pending = false;
  const normalize = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  function getVariant(flavor) {
    const title = { tropical: 'Tropical', rouges: 'Fruits rouges', agrumes: 'Agrumes' }[flavor];
    return (window.NuoroProductData?.variants || []).find(v => normalize(v.title) === normalize(title));
  }
  function pricing(state) {
    const variant = getVariant(state.flavor);
    const plan = variant?.plans?.[0];
    return {
      variant, plan,
      compare: (variant?.compareAtPrice || plan?.compareAtPrice || variant?.price || 0) / 100,
      once: (variant?.price || 0) / 100,
      subscription: (plan?.price || 0) / 100,
      quantityMultiplier: Number(state.qty) >= 2 ? 1 - (window.NuoroProductData?.duoDiscountPercent || 0) / 100 : 1
    };
  }
  function announce(message, root) {
    root = root || document.querySelector('[data-nuoro-module="Shop"]') || document.body;
    let box = root.querySelector('[data-nuoro-cart-error]');
    if (!box) {
      box = document.createElement('p'); box.dataset.nuoroCartError = ''; box.setAttribute('role', 'alert');
      box.style.cssText = 'color:#1d1d1b;font:600 15px/1.4 "Inter Tight",sans-serif;margin:12px 0;';
      (root.querySelector('#atc') || root.lastElementChild)?.after(box);
    }
    box.textContent = message; box.hidden = !message;
  }
  async function cart() {
    const response = await fetch(route('cart.js'), { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
    if (!response.ok) throw new Error('Impossible de charger le panier. Réessayez.');
    return response.json();
  }
  function count(cartData) {
    const qty = (cartData.items || []).filter(item => !item.properties?._isGiftProduct).reduce((sum, item) => sum + item.quantity, 0);
    document.querySelectorAll('.nuoro-module [aria-label="Panier"] .badge, [data-nuoro-cart-count]').forEach(el => {
      el.textContent = qty; el.hidden = qty === 0;
    });
  }
  async function open(trigger) {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) { window.location.assign(route('cart')); return; }
    drawer.setActiveElement?.(trigger || document.activeElement);
    drawer.open(trigger || document.activeElement);
    try { count(await cart()); } catch (_) { /* The existing cart remains usable. */ }
  }
  async function add(selection, root) {
    if (pending) return;
    const details = pricing({ flavor: selection.flavor, qty: selection.qty });
    const quantity = Number(selection.qty);
    if (!details.variant?.available) { announce('Cette saveur est momentanément indisponible.', root); return; }
    if (selection.sub && !details.plan) { announce('L’abonnement est indisponible pour cette saveur.', root); return; }
    if (!Number.isInteger(quantity) || quantity < 1 || quantity > 2) { announce('Choisissez une ou deux personnes.', root); return; }
    const buttons = [...(root || document).querySelectorAll('#atc,[data-atc-mirror]')];
    pending = true; buttons.forEach(b => { b.disabled = true; b.setAttribute('aria-busy', 'true'); });
    const releaseCart = window.NuoroCartGuard?.acquire();
    announce('', root);
    try {
      const drawer = document.querySelector('cart-drawer');
      drawer?.setActiveElement?.(document.activeElement);
      const item = { id: details.variant.id, quantity };
      if (selection.sub) item.selling_plan = details.plan.id;
      const response = await fetch(route('cart/add.js'), {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [item], sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: location.pathname })
      });
      const added = await response.json();
      if (!response.ok || added.status) throw new Error(added.description || 'Impossible d’ajouter le produit. Réessayez.');
      if (drawer && added.sections) drawer.renderContents(added);
      drawer?.open(buttons[0]);
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        await publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: String(details.variant.id), cartData: added });
      }
      if (!drawer) await open(buttons[0]);
    } catch (error) {
      announce(error.message || 'Une erreur est survenue. Réessayez.', root);
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartError, { source: 'product-form', errors: error.message, message: error.message });
      }
    } finally {
      releaseCart?.();
      pending = false; buttons.forEach(b => { b.disabled = false; b.removeAttribute('aria-busy'); });
    }
  }
  window.NuoroCommerce = { add, open, close: () => document.querySelector('cart-drawer')?.close(), pricing, getVariant, refresh: async () => count(await cart()) };
  document.addEventListener('click', event => {
    const trigger = event.target.closest('.nuoro-module [aria-label="Panier"], [data-nuoro-open-cart]');
    if (trigger) { event.preventDefault(); open(trigger); }
  });
  window.addEventListener('message', event => {
    if (event.source !== window || event.origin !== location.origin) return;
    if (event.data?.nuoroCartOpen) open();
  });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, async event => {
      if (event.source === 'product-form' && window.NuoroCartGuard) return;
      try { count(event.source === 'gift-sync' ? event.cartData : await cart()); } catch (_) {}
    });
  }
  cart().then(count).catch(() => {});
})();

